module.exports = __webpack_public_path__ + "static/media/img_feature_photo2@2x.813f958c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_feature_photo2@2x.webp
// module id = 802
// module chunks = 0